module.exports = __webpack_public_path__ + "img/apay.fe4f01ad.svg";